export default __webpack_public_path__ + "static/media/arrow-bottom.a82fbf17.svg";